export const approverValidation = (
  currentStep: number,
  lastStepIndex: number,
  pisRequest: any,
  hasApproverPermission: boolean,
  hasGroup: any,
) => {
  const regionToCompare = pisRequest?.res_pm_market?.region;
  const isRestricted = regionToCompare?.is_restricted;

  if (isRestricted) {
    return (
      currentStep === lastStepIndex &&
      pisRequest.status === "SUBMITTED" &&
      hasApproverPermission &&
      hasGroup(regionToCompare?.name)
    );
  }

  return (
    currentStep === lastStepIndex &&
    pisRequest.status === "SUBMITTED" &&
    hasApproverPermission &&
    !hasGroup(regionToCompare)
  );
};
